import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import * as r from "@radix-ui/react-toggle";
//#region src/components/toggle.tsx
var i = n("inline-flex items-center justify-center gap-2 rounded-md text-sm font-normal hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
		},
		size: {
			default: "h-9 px-2 min-w-9",
			sm: "h-8 px-1.5 min-w-8",
			lg: "h-10 px-2.5 min-w-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function a({ className: n, variant: a, size: o, ...s }) {
	return /* @__PURE__ */ t(r.Root, {
		"data-slot": "toggle",
		className: e(i({
			variant: a,
			size: o,
			className: n
		}), "disabled:text-(--neutral-400)"),
		...s
	});
}
//#endregion
export { a as Toggle, i as toggleVariants };
